module.exports = __webpack_public_path__ + "media/images/lb/463-0c6eb49551db19318969a8172def09cd.svg";